import { TelegramPostPreviewProps } from './TelegramPostPreview.model';
import styles from './TelegramPostPreview.module.scss';
import { FlexRow, FlexCell, Text, Panel } from '@epam/promo';
import React from 'react';
import { parseTelegramTokens } from './parseTelegramTokens';

export const TelegramPostPreview = ({
  channelName = 'Community Onboarding',
  title,
  message,
  avatarUrl, // TODO: set correct avatar image as default value
  attachments,
}: TelegramPostPreviewProps) => {
  const postPreview = () => {
    return title || message ? (
      <div className={styles.bubble}>
        <Text
          color="white"
          cx={styles['post-title']}
          fontSize="14"
          fontWeight="700"
          lineHeight="24"
          size="18">
          {title}
        </Text>
        <Text
          color="white"
          cx={styles['post-text']}
          fontSize="14"
          lineHeight="19"
          size="18">
          {parseTelegramTokens(message)}
        </Text>
        <svg
          aria-hidden="true"
          className={styles['bubble-tail']}
          height="18"
          viewBox="0 0 25 18"
          width="25"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14 1
               Q18 8 25 10
               Q20 18 1 20
               Q14 20 14 1
               Z"
          />
        </svg>
      </div>
    ) : null;
  };

  const attachmentsPreview = () => {
    if (attachments?.length) {
      return (
        <FlexRow
          cx={styles['post-attachments-container']}
          padding="18"
          rowGap="12"
          vPadding="36">
          {attachments.flatMap((attachment, index) => {
            if (!attachment.type.startsWith('image/')) {
              return [];
            }

            // Local File (create/upload flow) → object URL;
            // server attachment (loaded broadcast) → presigned url, which may be absent.
            const src =
              attachment instanceof File
                ? URL.createObjectURL(attachment)
                : attachment.url;

            if (!src) {
              return [];
            }

            return (
              <FlexCell
                key={attachment instanceof File ? index : attachment.id}>
                <img
                  alt={attachment.name}
                  className={styles['post-attachment']}
                  src={src}
                />
              </FlexCell>
            );
          })}
        </FlexRow>
      );
    }
  };

  return (
    <Panel cx={styles.wrapper}>
      <FlexRow
        alignItems="center"
        columnGap="12"
        cx={styles.header}
        justifyContent="start"
        padding="12">
        <img className={styles.avatar} src={avatarUrl} />
        <FlexCell grow={1}>
          <Text color="white" fontSize="16" fontWeight="600" size="18">
            {channelName}
          </Text>
          <Text cx={styles.handle} fontSize="14" size="18">
            bot
          </Text>
        </FlexCell>
      </FlexRow>
      <div className={styles.content}>
        {postPreview()}
        {attachmentsPreview()}
      </div>
    </Panel>
  );
};
